import { sileo } from 'sileo';

const DEFAULT_DESCRIPTIONS = {
    'Subtitles cleared': 'All subtitles were removed from this session.',
    'Language changed': 'Translation language updated.',
    'Audio enabled': 'Translated audio playback is now enabled.',
    'Audio disabled': 'Translated audio playback is now disabled.',
    'Playback speed updated': 'Audio playback speed was updated.',
};

export const withDefaults = (method, payload) => ({
    ...payload,
    description:
        payload.description ||
        DEFAULT_DESCRIPTIONS[payload.title] ||
        (method === 'error' ? 'Something went wrong. Please try again.' : 'Action completed successfully.'),
    position: 'top-center',
    duration: method === 'error' ? 6000 : 4000,
});

const notify = (method, payload) => {
    try {
        sileo[method](withDefaults(method, payload));
    } catch (error) {
        console.error('Notification failed', error);
    }
};

const notifications = {
    success: (payload) => notify('success', payload),
    error: (payload) => notify('error', payload),
    info: (payload) => notify('info', payload),
    warning: (payload) => notify('warning', payload),
};

export const toasterProps = {
    position: 'top-center',
    offset: { top: 8 },
    options: {
        autopilot: true,
        fill: '#ffffff',
        styles: { description: 'sileo-description' },
    },
};

export default notifications;
